const Footer = () => {
  return (
    <div className={`footer`}>
      <div className={`wrapper`}>
        <a href="/oferta.pdf" target="_blank">
          {" "}
          Публичная оферта{" "}
        </a>
        <a href="/politika.pdf" target="_blank">
          Политика конфиденциальности
        </a>
      </div>
    </div>
  );
};

export default Footer;
